// extracted by mini-css-extract-plugin
export default {"categories":"Categories_categories__k2b5z","item":"Categories_item__Ubq+E","itemActive":"Categories_itemActive__Q7ZEh"};